import "../css/services.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

export default function Services() {
  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from(".services-header", {
      scrollTrigger: {
        trigger: ".services-header",
        start: "top 80%",
      },
      opacity: 0,
      duration: 0.75,
      y: 20,
    });

    // Animate each service card independently
    gsap.utils.toArray(".service").forEach((card) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      // Animate text group (h3 + p)
      tl.from(card.querySelectorAll("h3, p"), {
        opacity: 0,
        y: 30,
        duration: 0.6,
        stagger: 0.2,
        ease: "power2.out",
      });

      // Animate the image wrapper differently
      tl.from(card.querySelector(".img-wrapper"), {
        opacity: 0,
        y: 80,
        duration: 0.8,
        ease: "power1.out",
      });
    });
  });

  return (
    <section className="services-section" id="services">
      <div className="services-header">
        <h1 className="services-title">Our Services</h1>
      </div>
      <div className="services-grid">
        <div className="service">
          <div className="service-content">
            <h3> Trusts</h3>
            <p>
              A trust is a legal arrangement in which a trustee manages assets
              for the benefit of the designated beneficiaries. Whether your
              objective is asset protection, tax efficiency, or ensuring a
              smooth transfer of wealth to your loved ones, we provide strategic
              guidance and comprehensive support to create a trust that meets
              your needs and complies with current laws.
            </p>
          </div>
        </div>
        <div className="service">
          <div className="service-content">
            <h3>Healthcare Directives and Powers of Attorney</h3>
            <p>
              A comprehensive estate plan addresses not only what happens after
              death, but also what happens if you become incapacitated. We
              counsel clients through the creation of Advance Healthcare
              Directives, HIPAA Authorizations, and Powers of Attorney. These
              documents designate trusted individuals to manage your medical and
              financial matters, without the interference of the court.
            </p>
          </div>
        </div>
        <div className="service">
          <div className="img-wrapper">
            <img src="/document-prep.jpg" alt="" />
          </div>
        </div>
        <div className="service">
          <div className="img-wrapper">
            <img src="/trust-support.jpg" alt="" />
          </div>
        </div>

        <div className="service">
          <div className="service-content">
            <h3>Probate</h3>
            <p>
              Probate can be complicated and time-consuming, but expert guidance
              can make the process smoother. We assist executors and
              beneficiaries with all aspects of probate and estate
              administration, from filing necessary documents to distributing
              assets according to the decedent’s wishes. Our goal is to help
              clients navigate the legal requirements efficiently while
              minimizing stress and delays.
            </p>
          </div>
        </div>
        <div className="service">
          <div className="service-content">
            <div className="service-content">
              <h3>Trust Administration</h3>
              <p>
                Trust administration involves the careful management and
                distribution of a trust’s assets according to the instructions
                laid out in the trust document. A trustee’s responsibilities
                include identifying and valuing assets, handling any debts or
                taxes owed by the trust, and ultimately distributing assets to
                the beneficiaries. We guide trustees through each step of the
                process to ensure compliance with legal requirements and a
                smooth transition of assets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
